import gql from 'graphql-tag';

export default gql`
  query ($id: MongoID!) {
    contentGroupId(_id: $id) {
      _id
      name
      description
      subject {
        _id
        name
      }
      certificateconfig {
        status
        name
        description
        timestatus
        certificatetime
        signature {
          typesign
          firstname
          lastname
          signatureURL
        }
        position
        logoURL
        backgroundURL
      }
      contents {
        _id
        name
        type
      }
    }
  }
`;
